import { DefaultButton, Panel, PrimaryButton, useTheme } from "@fluentui/react";
import React from "react";
import { useLanguage } from "../languages";
import { Column } from "./Column";
import { Grid } from "./Grid";
import { Row } from "./Row";
export const StandarPanel = (props) => {
    const theme = useTheme();
    const lang = useLanguage();
    if (!props.isOpen)
        return React.createElement(React.Fragment, null);
    const showAcceptButton = props.hideAcceptButton == null || typeof props.hideAcceptButton === 'boolean' && !props.hideAcceptButton;
    const showCloseButton = props.showCloseButton == null || typeof props.showCloseButton === 'boolean' && props.showCloseButton;
    return React.createElement(Panel, { isOpen: props.isOpen, type: props.type, headerText: props.headerText, hasCloseButton: false, onRenderHeader: props.onRenderHeader, styles: {
            footerInner: {
                backgroundColor: theme.palette.white,
            }
        }, onRenderFooterContent: () => (React.createElement(Grid, null,
            React.createElement(Row, null,
                React.createElement(Column, { size: 12, style: { textAlign: 'right' } }, typeof props.onRenderFooter === 'function'
                    ? props.onRenderFooter()
                    : React.createElement(React.Fragment, null,
                        showAcceptButton && React.createElement(PrimaryButton, { text: props.acceptButtonText || lang.accept, onClick: props.onAccept }),
                        showCloseButton && React.createElement(DefaultButton, { text: props.closeButtonText || lang.toBack, style: { marginLeft: '8px' }, onClick: () => { var _a; return (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props); } })))))), isFooterAtBottom: true }, props.children);
};
